import { ModuleFE_MultiVar } from './ModuleFE_MultiVar.js';
export const ModulePackFE_MultiVar = [ModuleFE_MultiVar];
//# sourceMappingURL=module-pack.js.map